<app-splash-screen></app-splash-screen>
<app-modals-regularizacion></app-modals-regularizacion>
<router-outlet></router-outlet>
<!-- <router-outlet></router-outlet> -->
<app-toast-notification></app-toast-notification>